import { AxiosStatic } from "axios";
import { IFileUploadResponseData } from "../CourseAuthorApi";
import { AxiosInterceptedResult } from "../interceptors";
import { IUsersApiDependencies } from "../UsersApi";

export interface IMediaApi {
  uploadFile: (files: File, accountId: string) => Promise<AxiosInterceptedResult<IFileUploadResponseData>>;
  uploadViaUrl: (link: string, accountId: string) => Promise<AxiosInterceptedResult<IFileUploadResponseData>>;
}

export default class MediaApi implements IMediaApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IUsersApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public uploadFile = (file: File, accountId: string): Promise<AxiosInterceptedResult<IFileUploadResponseData>> => {
    const formData = new FormData();

    formData.append("files[]", file);
    return this.axios.post(`${this.apiRoot}/media/_upload?accept=text/plain&activeUser=${accountId}`, formData, {
      headers: {
        Accept: "*/*",
        "Content-Type": "multipart/form-data",
      },
    });
  };

  public uploadViaUrl = (
    link: string,
    activeUser: string
  ): Promise<AxiosInterceptedResult<IFileUploadResponseData>> => {
    return this.axios.post(`${this.apiRoot}/media/_uploadViaUrl`, link, {
      params: { activeUser },
    });
  };
}
